import { Component, OnInit, ViewChild, Type } from '@angular/core';
import { ImageCropperComponent } from './img-cropper/imageCropperComponent';
import { CropperSettings } from './img-cropper/cropperSettings';
import { Bounds } from './img-cropper/model/bounds';
import { CompleterService, CompleterData, CompleterItem } from 'ng2-completer';
import { Element } from './Element';
import { DashboardService } from './dashboard.service';
import { ImagesService } from './images.service';
import { User } from './User';
import { Photo } from './Photo';
import { Tag } from './Tag';
import { DayInformation } from './DayInformation';
import { DayInformationService } from './day-information.service';
import { GeolocationService } from './geolocation.service';
import { TagsService } from './tags.service';
import { CITIES } from '../../constants/cities';
import { Router, RouterOutlet } from '@angular/router';

@Component({
    selector: 'dashboard',
    template: require('./dashboard.component.html'),    
    providers: [DashboardService, ImagesService, CompleterService, DayInformationService, GeolocationService, TagsService]
})

export class SuperUserDashboardComponent extends Type implements OnInit {
    
    element: Element;
    photos: Photo[] = [];
    limitTags: number;
    limitPhotos: number;
    dayInformation: any[] = [];
    lastDay: any;
    dayInformationRecived: any[] = [];
    photos_number: number;
    selected: number;
    user: User;
    code: number;
    tags: Tag[] = [];
    tagsHaveNot: Tag[] = [];
    modalTags: Tag[] = [];
    classMapModal: any;
    classTagsModal: any;
    addingPhoto: boolean;
    uploadProgress: number;
    overMain: boolean;
    cityNotFound: boolean;
    cityNotIntroduced: boolean;
    lastDaySaved: boolean;
    tagHover: number;
    selectedTag: number;
    tagsModalFilter: string;
    tagsSelectedsOnMOdal: number;
    reachedLimitTags: boolean;
    reachedLimitTagsOnModal: boolean;

    days: any[] = [
        { id: 1, name: "MONDAY" },
        { id: 2, name: "TUESDAY" },
        { id: 3, name: "WEDNESDAY" },
        { id: 4, name: "THURSDAY" },
        { id: 5, name: "FRIDAY" },
        { id: 6, name: "SATURDAY" },
        { id: 7, name: "SUNDAY" }
    ];

    modalTitle: String;

    data1: any;
    data2: any;
    cropperSettings1: CropperSettings;
    cropperSettings2: CropperSettings;
    @ViewChild('cropper', undefined) cropper: ImageCropperComponent;
    @ViewChild('cropper_main', undefined) cropper2: ImageCropperComponent;

    editName: number;
    editDescription: number;

    imageDelete: number;
    selectedDay: number;
    imageSelected: String;

    subrole: number;

    private dataService: CompleterData;
    private searchString: string;

    marker: any;
    myLatitude: number;
    myLongitude: number;

    editFacebook: boolean;
    editWeb: boolean;    

    facebook_errorCode: number;
    web_errorCode: number;

    constructor(_parentRouter: Router, private _dashboardService: DashboardService, private _completerService: CompleterService,private _imagesService: ImagesService,private _dayInformationService: DayInformationService,private _geolocationService: GeolocationService,private _tagsService: TagsService) {
        super();

        this.dataService = _completerService.local(CITIES, 'name', 'name');

        this.myLatitude = 0;
        this.myLongitude = 0;

        this.classMapModal = { 'model': true, 'show': false, 'hide': true };
        this.classTagsModal = { 'model': true, 'show': false, 'hide': true };
        this.addingPhoto = false;
        this.code = 0;
        this.uploadProgress = 0;
        this.selected = 0;
        this.overMain = false;

        this.cropperSettings1 = new CropperSettings();
        this.cropperSettings1.width = 320;
        this.cropperSettings1.height = 400;

        this.cropperSettings1.croppedWidth = 320;
        this.cropperSettings1.croppedHeight = 400;

        this.cropperSettings1.canvasWidth = 440;
        this.cropperSettings1.canvasHeight = 450;

        this.cropperSettings1.minWidth = 320;
        this.cropperSettings1.minHeight = 400;

        this.cropperSettings1.rounded = false;

        this.cropperSettings1.fileInputName = "addImage";

        this.cropperSettings1.cropperDrawSettings.strokeWidth = 1;
        this.cropperSettings1.cropperDrawSettings.strokeColor = "rgb(44, 44, 44)";

        this.cropperSettings2 = new CropperSettings();

        this.cropperSettings2.width = 405;
        this.cropperSettings2.height = 270;

        this.cropperSettings2.croppedWidth = 405;
        this.cropperSettings2.croppedHeight = 270;

        this.cropperSettings2.canvasWidth = 500;
        this.cropperSettings2.canvasHeight = 334;

        this.cropperSettings2.minWidth = 405;
        this.cropperSettings2.minHeight = 270;

        this.cropperSettings2.cropperDrawSettings.strokeWidth = 1;
        this.cropperSettings2.cropperDrawSettings.strokeColor = "rgb(44, 44, 44)";

        this.editName = 0;
        this.editDescription = 0;

        this.cropperSettings2.rounded = false; 

        this.cropperSettings2.fileInputName = "profileImage";

        this.data1 = {};
        this.data2 = {};

        this.imageDelete = -1;
        this.imageSelected = "";

        this.selectedDay = -1;

        this.marker = {
            lat: 0,
            lng: 0,
            label: 'A',
            draggable: true
        };

        this.cityNotFound = false;
        this.cityNotIntroduced = false;
        this.lastDaySaved = false;
        this.lastDay = { 'city': null, 'name': "", 'information': "", 'latitude': "", 'longitude': "" };
        this.tagHover = -1;
        this.tagsModalFilter = "";
        this.tagsHaveNot = [];
        this.modalTags = [];

        this.user = {'email': "", 'id': 0, 'name': "", 'nif': "", 'phone': "", 'subrole': 0 };
        this.tagsSelectedsOnMOdal = 0;
        this.reachedLimitTags = false;
        this.reachedLimitTagsOnModal = false;

        this.editWeb = false;
        this.editFacebook = false;        

        this.facebook_errorCode = 0;
        this.web_errorCode = 0;
    }

    ngOnInit() {
        var that = this;
        this.photos_number = 0;
        this._dashboardService.getElement().then(element => {                
            this.element = element;                         
            this.photos = element.photos;            
            this.dayInformationRecived = element.dayInformation; 
            this.mountDayInformation(element.dayInformation); 
            this.photos_number = this.photos.length; 

            if(this.element.web_site == null || this.element.web_site == undefined || this.element.web_site == "null" || this.element.web_site == "undefined") {
                this.element.web_site = "";
            }

            if(this.element.facebook_site == null || this.element.facebook_site == undefined || this.element.facebook_site == "null" || this.element.facebook_site == "undefined") {
                this.element.facebook_site = "";
            } else {
                this.element.facebook_site = this.validateFacebookSite(this.element.facebook_site);
            }

        });
        this._dashboardService.getProfile().then(
            user => {
                this.user = user.row[0];                
                this.subrole = this.user.subrole;
                if (this.user.subrole == 1 || this.user.subrole == 3) {
                    this.limitTags = -1;
                    this.limitPhotos = 100;                    
                }
                else if(this.user.subrole == 2 || this.user.subrole == 4){
                    this.limitTags = 30;
                    this.limitPhotos = 50;
                } else {
                    this.limitTags = 5;
                    this.limitPhotos = 4;
                }
            }
        );
        this._geolocationService.getLocation().subscribe(
            function (position) {
                that.myLatitude = position.coords.latitude;
                that.myLongitude = position.coords.longitude;                
            }
        );

        this._tagsService.getTagsOfElement().then(tagsRecived => {
            this.tags = tagsRecived;
        });
    }

    cropped(result: any) {
        if (result.save == 1) {
            if (this.checkMaxPhotos()) {                
                this.psdUploadHandler(result.image, false, true, result.price);
            }
        }
    }

    addTag(event: any) {
        this.reachedLimitTagsOnModal = false; 
        if(this.limitTags == -1 || this.limitTags > this.tags.length) {
            this.reachedLimitTags = false;
            this.tagsSelectedsOnMOdal = 0;
            this._tagsService.getTagsThatElementHaveNot().then(tags => {
                for (var i = 0; i < tags.length; i++) {
                    tags[i].selected = false;
                }
                this.tagsHaveNot = tags;
                this.modalTags = tags;
            });
            this.classTagsModal.show = true;
            this.classTagsModal.hide = false;
        } else {
            this.reachedLimitTags = true;
        }
    }

    selectTag(tag: Tag) {   
        this.reachedLimitTagsOnModal = false;             
        if (!tag.selected) {
            if(this.limitTags == -1 || this.limitTags > this.tags.length + this.tagsSelectedsOnMOdal) {
                tag.selected = true;
                this.tagsSelectedsOnMOdal++;
            } else {
                this.reachedLimitTagsOnModal = true;
            }
        } else {
            tag.selected = false;
            this.tagsSelectedsOnMOdal--;
        }
    }

    getColor(tag: Tag) {

        if (tag.selected) {

            return "#97D685";

        } else {

            return "LightSteelBlue";

        }

    }

    public isTagSelected(tag: Tag): boolean {
        if (tag.selected) {

            return true;

        } else {

            return false;

        }

    }

    cropped2(result: any) {
        if (result.save == 1) {            
            this.psdUploadHandler(result.image, true, true, -1);
        }
    }

    mountDayInformation(dayInfo: DayInformation[]) {
        var o = 0;
        for (var i = 0; i < this.days.length; i++) {
            if (dayInfo[o] !== undefined && this.days[i].id == dayInfo[o].id) {
                this.dayInformation.push(dayInfo[o]);
                o++;
            }
            else {
                this.dayInformation.push({
                    city: 0,
                    element_id: this.element,
                    id: i + 1,
                    information: "",
                    latitude: "",
                    longitude: "",
                    name: ""
                });
            }
        }
    }

    addPhoto() {
        this.addingPhoto = true;
    }

    onFileAddedMain(event: any) {
        var files = event.srcElement.files;
        var re = /(?:\.([^.]+))?$/;
        var ext = re.exec(event.srcElement.files[0].name)[1];
        if (ext != "jpg" && ext != "png" && ext != "jpeg") {
            this.code = 121;
        }
        else if (event.srcElement.files[0].size > 2000000) {
            this.code = 122;
        }
        else {
            this.code = 120;
            this.psdUploadHandler(event.srcElement.files[0], true, false, -1);

        }
    }

    onFileAdded(event: any) {
        var files = event.srcElement.files;
        var re = /(?:\.([^.]+))?$/;
        var ext = re.exec(event.srcElement.files[0].name)[1];
        if (ext != "jpg" && ext != "png" && ext != "jpeg") {
            this.code = 21;
        }
        else if (event.srcElement.files[0].size > 2000000) {
            this.code = 22;
        }
        else if (this.photos_number >= 10) {
            this.code = 23;
        }
        else {
            this.code = 20;
            this.psdUploadHandler(event.srcElement.files[0], false, false, -1);

        }
    }

    checkMaxPhotos() {

        if (this.photos_number >= this.limitPhotos) {
            this.code = 23;
            return false;
        }

        return true;
    }

    public psdUploadHandler(file: File, mainImage: boolean, encodedImage: boolean, price: number) {
        let result: any;        
        this._imagesService.getObserver()
            .subscribe(progress => {
                this.uploadProgress = progress;
            });

        try {
            if (encodedImage) {
                if (!mainImage) {
                    result = this._imagesService.uploadEncoded(file, price).then(
                        data => {                            
                            this._imagesService.getImages(this.element.id).then(photos => { this.photos = photos; this.photos_number = photos.length; });
                        }
                    );
                }
                else {
                    result = this._imagesService.uploadEncodedMain(file).then(
                        data => { this._imagesService.getImageMain(this.element.id).then(data => { this.element.mainImage = data.mainImage; });}
                    );
                }
            }
            else {
                if (mainImage) {
                    result = this._imagesService.uploadMain(file).then(
                        data => { this._imagesService.getImageMain(this.element.id).then(data => { this.element.mainImage = data.mainImage; }); }
                    );
                }
                else {
                    result = this._imagesService.upload(file).then(
                        data => { this._imagesService.getImages(this.element.id).then(photos => { this.photos = photos; this.photos_number = photos.length; }); }
                    );

                }
            }
        } catch (error) {
            document.write(error)
        }

    }

    public over(id: number) {
        this.selected = id;
    }

    public overMainF() {
        this.overMain = true;
    }

    public outMain() {
        this.overMain = false;
    }

    public out(id: number) {
        if (this.selected == id) {
            this.selected = 0;
        }
    }

    public selectImage(id: number) {
        this.imageDelete = -1;
        for (var i = 0; i < this.photos.length; i++) {            
            if (this.photos[i].id == id) this.imageSelected = this.photos[i].url;
        }
        this.classMapModal.show = true;
        this.classMapModal.hide = false;
    }

    public deleteImage(id: number) {
        this.imageDelete = id;
        for (var i = 0; i < this.photos.length; i++) {            
            if (this.photos[i].id == id) this.imageSelected = this.photos[i].url;
        }
        this.classMapModal.show = true;
        this.classMapModal.hide = false;

    }

    public deleteConfirm() {
        this._imagesService.deleteImage(this.imageDelete).subscribe(
            data => { this.imageDelete = 0; this._imagesService.getImages(this.element.id).then(photos => { this.photos = photos; this.photos_number = photos.length; }); }
        );
        this.classMapModal.show = false;
        this.classMapModal.hide = true;
    }

    clickedMarker(label: string, index: number) {
        console.log(`clicked the marker: ${label || index}`);
    }

    editNameF() {
        if (this.editName == 0)
            this.editName = 1;
        if (this.editName == 2)
            this.editName = 0;
    }

    postName(isKey: boolean) {
        this._dashboardService.postName(this.element.comercial_name);
        if (isKey)
            this.editName = 0;
        else
            this.editName = 2;
    }

    editDescriptionF() {
        if (this.editDescription == 0)
            this.editDescription = 1;
        if (this.editDescription == 2)
            this.editDescription = 0;
    }

    postDescription() {
        this._dashboardService.postDescription(this.element.description);
        this.editDescription = 2;
    }

    saveTagsModal() {

        var selectedTags: Tag[] = [];

        for (var i = 0; i < this.modalTags.length; i++) {

            if (this.modalTags[i].selected) {

                selectedTags.push(this.modalTags[i]);

            }

        }

        this._tagsService.addTags(selectedTags).then(result => {
            console.log(result);
            if (result == "1") {
                this.closeTagsModal();
                this._tagsService.getTagsOfElement().then(tags => {
                    for (var i = 0; i < tags.length; i++) {
                        tags[i].selected = false;
                    }
                    this.tags = tags;
                });
            }
        });
    }

    closeModal() {
        this.classMapModal.show = false;
        this.classMapModal.hide = true;
    }

    closeTagsModal() {

        for (var i = 0; i < this.tags.length; i++) {

            this.tags[i].selected = false;

        }

        this.tagsModalFilter = "";

        this.classTagsModal.show = false;
        this.classTagsModal.hide = true;

    }

    editDay(id: number) {

        if (!this.lastDaySaved && this.selectedDay != -1) {

            this.dayInformation[this.selectedDay - 1].name = this.lastDay.name;
            this.dayInformation[this.selectedDay - 1].city = this.lastDay.city;
            this.dayInformation[this.selectedDay - 1].latitude = this.lastDay.latitude;
            this.dayInformation[this.selectedDay - 1].longitude = this.lastDay.longitude;
            this.dayInformation[this.selectedDay - 1].information = this.lastDay.information;
            this.cityNotFound = false;
            this.cityNotIntroduced = false;

        }

        this.lastDaySaved = false;

        if (this.selectedDay == id) {

            this.selectedDay = -1

        } else {

            this.selectedDay = id;

            this.lastDay.city = this.dayInformation[this.selectedDay - 1].city;
            this.lastDay.name = this.dayInformation[this.selectedDay - 1].name;
            this.lastDay.latitude = this.dayInformation[this.selectedDay - 1].latitude;
            this.lastDay.longitude = this.dayInformation[this.selectedDay - 1].longitude;
            this.lastDay.information = this.dayInformation[this.selectedDay - 1].information;

            console.log(this.dayInformation[this.selectedDay - 1]);
            if (this.dayInformation[this.selectedDay - 1].latitude == "") {
                console.log("null marker0");
                this.marker =
                    {
                        lat: 0,
                        lng: 0,
                        draggable: true
                    };
            }
            else {
                console.log("marker " + this.dayInformation[this.selectedDay - 1].latitude + " " + this.dayInformation[this.selectedDay - 1].longitude);
                this.marker =
                    {
                        lat: Number(this.dayInformation[this.selectedDay - 1].latitude),
                        lng: Number(this.dayInformation[this.selectedDay - 1].longitude),
                        draggable: true
                    };
                console.log("marker " + this.marker.lat + " " + this.marker.lng);
            }
            if ((this.marker.lat == 0 && this.marker.lng == 0) && (this.myLatitude != 0 && this.myLongitude != 0)) {
                this.marker.lat = this.myLatitude;
                this.marker.lng = this.myLongitude;
                this.dayInformation[this.selectedDay - 1].latitude = "" + this.myLatitude;
                this.dayInformation[this.selectedDay - 1].longitude = "" + this.myLongitude;
            }
        }
    }

    isEditDay(id: number) {
        return id == this.selectedDay;
    }

    mapClicked($event: any) {
        this.marker.lat = $event.coords.lat;
        this.marker.lng = $event.coords.lng;
        this.dayInformation[this.selectedDay - 1].latitude = "" + $event.coords.lat;
        this.dayInformation[this.selectedDay - 1].longitude = "" + $event.coords.lng;
    }

    onCitySelected($event: any) {

        console.log($event);
        //this.dayInformation[this.selectedDay - 1].city = $event.originalObject.id;

    }

    postDayInformation(day: any) {

        var editDay = false;

        if (day.name.length > 0) {

            var cities = CITIES.filter(city => city.name.toLowerCase() == day.name.toLowerCase());

            if (cities.length != 0 && cities[0] !== undefined && cities[0] !== null) {

                console.log(day);
                day.name = cities[0].name;
                day.city = cities[0].id;
                editDay = true;
                this.cityNotFound = false;

            } else {

                this.cityNotFound = true;
                editDay = false;

            }

            this.cityNotIntroduced = false;

        } else {

            this.cityNotIntroduced = true;
            this.cityNotFound = false;
            editDay = false;

        }
        console.log(day);
        if (editDay) {
            this.lastDaySaved = true;
            console.log(this.dayInformation[this.selectedDay - 1]);
            this._dayInformationService.editDayInformation(this.dayInformation[this.selectedDay - 1]).then(
                data => {
                    console.log(data.code);
                    if (data.code == "1") {
                        console.log("HOLA");
                    }


                    console.log(this.dayInformation[this.selectedDay - 1]);
                }
            );

            this.dayInformation[this.selectedDay - 1].city = day.city;
            this.dayInformation[this.selectedDay - 1].name = day.name;
            this.dayInformation[this.selectedDay - 1].information = day.information;
            this.dayInformation[this.selectedDay - 1].latitude = day.latitude;
            this.dayInformation[this.selectedDay - 1].longitude = day.longitude;
            this.selectedDay = -1;
        }

    }

    deleteDayInformation(day: any) {
        this.cityNotFound = false;
        this.cityNotIntroduced = false;
        day.name = null;
        day.city = null;
        day.latitude = null;
        day.longitude = null;
        day.information = null;
        this.lastDaySaved = true;
        this._dayInformationService.editDayInformation(this.dayInformation[this.selectedDay - 1]).then(
            data => {
                console.log(data);
                this.marker.lat = 0;
                this.marker.lng = 0;
                this.selectedDay = -1;
            }
        );
    }

    ubicateCity(day: any) {

        var ubicateCity = false;

        if (day.name.length > 0) {

            var cities = CITIES.filter(city => city.name.toLowerCase() == day.name.toLowerCase());

            if (cities.length != 0 && cities[0] !== undefined && cities[0] !== null) {

                day.name = cities[0].name;
                day.city = cities[0].id;
                ubicateCity = true;
                this.cityNotFound = false;

            } else {

                this.cityNotFound = true;
                ubicateCity = false;

            }

            this.cityNotIntroduced = false;

        } else {

            this.cityNotIntroduced = true;
            this.cityNotFound = false;
            ubicateCity = false;

        }

        if (ubicateCity) {
            this._dayInformationService.getDayLocation(this.dayInformation[this.selectedDay - 1]).then(res => {
                this.marker.lat = res['latitude'];
                this.marker.lng = res['longitude'];
                day.latitude = res['latitude'];
                day.longitude = res['longitude'];
                this.dayInformation[this.selectedDay - 1].latitude = "" + res['latitude'];
                this.dayInformation[this.selectedDay - 1].longitude = "" + res['longitude'];
            });
        }

    }

    tagsModalFilterChanged() {

        if (this.tagsModalFilter != null && this.tagsModalFilter != undefined && this.tagsModalFilter != "") {

            this.modalTags = [];
            for (var i = 0; i < this.tagsHaveNot.length; i++) {

                var tagName = this.toUpperCaseReplacingAccents(this.tagsHaveNot[i].name);
                var filterText = this.toUpperCaseReplacingAccents(this.tagsModalFilter);

                if (tagName.indexOf(filterText) !== -1) {

                    this.modalTags.push(this.tagsHaveNot[i]);

                }

            }

        } else {

            this.modalTags = this.tagsHaveNot;

        }

    }

    public toUpperCaseReplacingAccents(text: string): string {

        var mapObj = {
            Á: "A",
            À: "A",
            Ä: "A",
            É: "E",
            È: "E",
            Ë: "E",
            Í: "I",
            Ì: "I",
            Ï: "I",
            Ó: "O",
            Ò: "O",
            Ö: "O",
            Ú: "U",
            Ù: "U",
            Ü: "U"
        };

        var trim = text.toUpperCase();
        trim = trim.replace(/Á|À|Ä|É|È|Ë|Í|Ì|Ï|Ó|Ò|Ö|Ú|Ù|Ü/g, function (char) {
            return mapObj[char];
        });

        return trim;

    }

    public mouseOverTag(id: number): void {
        this.tagHover = id;
    }

    public mouseLeaveTag(): void {
        this.tagHover = -1;
    }

    public overTag(id: number): boolean {
        return this.tagHover == id || this.selectedTag == id;
    }

    public deleteTag(id: number): void {
        console.log("DELETE TAG " + id);
        this._tagsService.deleteTag(id).then(res => {
            if (Number(res) == 1) {
                this._tagsService.getTagsOfElement().then(tags => {
                    for (var i = 0; i < tags.length; i++) {
                        tags[i].selected = false;
                    }
                    this.tags = tags;
                });
            }

        });
    }

    public selectTagMain(id: number): void {
        this.selectedTag = id;
    }

    public editImagePrice(image: any) {
        image.edit = false;
        this._imagesService.editPrice(image.id, image.price);
    }

    public editImagePriceKey(event: any, image: Photo) {
        if(event.keyCode == 13) {
            this.editImagePrice(image);
        }
    }

    public editWebSite() {
        if(this.editWeb) {
            this.web_errorCode = 0;
            this.editWeb = false;
        } else {
            this.editWeb = true;
        }
    }

    public editFacebookSite() {
        if(this.editFacebook) {
            this.facebook_errorCode = 0;
            this.editFacebook = false;
        } else {
            this.editFacebook = true;
        }
    }

    public saveWebSite(web: string) {       
        if(web == "") {
            this.web_errorCode = 1;
        } else {
            this._dashboardService.editWebSite(web);
            this.element.web_site = web;
            this.editWeb = false;
            this.web_errorCode = 0;
        }                
    }

    public saveFacebookSite(facebook: string) {
        if(facebook == "") {
            this.facebook_errorCode = 1;
        } else {
            if(facebook.indexOf("www.facebook.com") == -1 && facebook.indexOf("www.facebook.es") == -1) {
                console.log("hola");
                console.log(facebook);
                if(facebook.indexOf("/") == 0) {
                    console.log("ie");
                    var facebookUrl: string = "www.facebook.com" + facebook;
                    console.log(facebookUrl);
                } else {
                    console.log("ia");
                    var facebookUrl: string = "www.facebook.com/" + facebook;
                    console.log(facebookUrl);
                }                
                console.log(facebookUrl);
            } else {
                var facebookUrl: string = facebook;
            }
            console.log(facebookUrl);
            this._dashboardService.editFacebookSite(facebookUrl);
            this.element.facebook_site = this.validateFacebookSite(facebook);
            this.editFacebook = false;
            this.facebook_errorCode = 0;
        }                
    }

    private validateFacebookSite(facebook: string): string {
        if(facebook.indexOf("www.facebook.com") >= 0 || facebook.indexOf("www.facebook.es") >= 0) {
            var urlParams: string[] = facebook.split("/");
            var facebookUrl: string = "/";
            for(var i = 1; i < urlParams.length; i++) {
                facebookUrl += urlParams[i];
                if(i != urlParams.length - 1) {
                    facebookUrl += "/";
                }
            }
            return facebookUrl;
        } else {
            if(facebook.indexOf("/") != 0) {
                return "/" + facebook;
            } else {
                return facebook;
            }            
        }
    }

}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/super_user/dashboard/dashboard.component.ts
 **/